<script setup lang="ts">
interface HotelDescriptionTagsSectionProps {
  tagImgUrls: string[];
}

const props = defineProps<HotelDescriptionTagsSectionProps>();
</script>

<template>
  <div class="hotel-description-tags-section">
    <img
      v-for="url in props.tagImgUrls"
      :key="url"
      :alt="$t('a11y.hotel_theme')"
      class="tag"
      :src="url"
    />
  </div>
</template>

<style scoped lang="scss">
.hotel-description-tags-section {
  display: flex;
  flex-wrap: wrap;
  gap: var(--spacing-8);

  .tag {
    width: 115px;
    height: 26px;
  }
}
</style>
